import { __ } from '@wordpress/i18n'
import toast from 'react-hot-toast'

import { useGlobalStore } from '../../frontend/libs/stores/globalStore'

export async function handleResponse(response: Response, method: string) {
  if (!response.ok) {
    const data = await response.json()
    const { setLoginPopupOpen } = useGlobalStore.getState()

    const messageElement = document.createElement('span')
    messageElement.innerHTML = data?.error?.message || data?.message

    if (response.status === 401 && method !== 'GET') {
      toast.error(
        __(
          "It looks like you're not signed in. Please sign in to continue.",
          'asavagroup',
        ),
      )
      setLoginPopupOpen(true)
    } else if (data?.error?.message) {
      // toast.error(messageElement.textContent);
      console.log(data.error)
    }

    return Promise.reject(data)
  }

  return response.json()
}

export async function getRequest(url: string) {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  return handleResponse(response, 'GET')
}

export async function sendRequest<Request>(
  url: string,
  { arg }: { arg: Request },
) {
  const response = await fetch(url, {
    body: JSON.stringify(arg),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })

  return handleResponse(response, 'POST')
}

export async function putRequest<Request>(
  url: string,
  { arg }: { arg: Request },
) {
  const response = await fetch(url, {
    body: JSON.stringify(arg),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
  })

  return handleResponse(response, 'PUT')
}

export async function deleteRequest(url: string) {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })

  return handleResponse(response, 'DELETE')
}
